export default __webpack_public_path__ + "static/media/smart_up.1662499f.png";